import { TurmaAtual } from '../../../contexts/turmas/turmas-atuais/turmas-atuais.types';
import { HorarioTurma, LocalTurma } from '../../../contexts/turmas/turmas.types';
import { EducadorTurma, FormatoTurma, PerfilResponsavel, TipoCurso } from '../../../types';
import { FixtureTurmaAtual } from './turma-atual.types';

export const turmaAtualFixture: FixtureTurmaAtual = () => {
  const mock: TurmaAtual = {
    id: '1',
    marca: 'estacio',
    nome: 'História da Arte',
    codigoDisciplina: 'ARA_TST',
    codigoEntrega: 'estacio_15',
    formato: FormatoTurma.PRESENCIAL,
    periodoAcademico: '2021.2',
    campus: 'Rio de Janeiro',
    educadorResponsavel: {
      nome: 'Claudia Oliveira',
      perfil: PerfilResponsavel.PROFESSOR,
    },
    local: {
      salas: ['417'],
      blocos: ['A'],
    },
    horarios: [
      {
        diaSemana: 'segunda',
        horaInicio: '09:00',
        horaFim: '10:00',
      },
    ],
    educadores: [
      {
        nome: 'Jeff Bezos',
        perfil: PerfilResponsavel.PROFESSOR,
      },
    ],
    possuiExercicios: true,
    totalAlunosMatriculados: 60,
    tipoTurma: 'NORMAL',
    tipoCurso: 'GRADUAÇÃO',
    idExterno: 'id_turma_1',
    dataAtualizacao: '2023-01-01T00:00:00.000+00:00',
    teams: false,
  };

  return {
    create: () => {
      const entrega: TurmaAtual = { ...mock };

      return {
        id: function (param: string) {
          entrega.id = param;
          return this;
        },
        marca: function (param: string) {
          entrega.marca = param;
          return this;
        },
        nome: function (param: string) {
          entrega.nome = param;
          return this;
        },
        campus: function (param: string) {
          entrega.campus = param;
          return this;
        },
        codigo: function (param: string) {
          entrega.codigoEntrega = param;
          return this;
        },
        codigoDisciplina: function (param: string) {
          entrega.codigoDisciplina = param;
          return this;
        },
        digital: function () {
          entrega.formato = FormatoTurma.DIGITAL;
          return this;
        },
        periodoAcademico: function (param: string) {
          entrega.periodoAcademico = param;
          return this;
        },
        semPeriodoAcademico: function () {
          entrega.periodoAcademico = undefined;
          return this;
        },
        educadoresDaEntrega: function (param: EducadorTurma[]) {
          entrega.educadores = param;

          return this;
        },
        educadorResponsavel: function (param: EducadorTurma) {
          entrega.educadorResponsavel = param;

          return this;
        },
        alunosMatriculados: function (param: number) {
          entrega.totalAlunosMatriculados = param;

          return this;
        },
        horariosDaEntrega: function (param: HorarioTurma[]) {
          entrega.horarios = param;

          return this;
        },
        local: function (param: LocalTurma) {
          entrega.local = param;

          return this;
        },
        turmaPai: function () {
          entrega.tipoTurma = 'PAI';

          return this;
        },
        tipoCurso: function (param: TipoCurso) {
          entrega.tipoCurso = param;
          return this;
        },
        cursoEspecializacao: function () {
          entrega.tipoCurso = 'ESPECIALIZAÇÃO';
          return this;
        },
        onboarding: function () {
          entrega.id = 'yduqs_COM0001';
          entrega.codigoEntrega = 'ARACOM0001';
          entrega.campus = null;
          entrega.educadores = [];
          entrega.horarios = null;
          entrega.local = null;
          entrega.totalAlunosMatriculados = 0;
          entrega.codigoDisciplina = 'COM0001';
          entrega.nome = 'PRIMEIROS PASSOS';

          return this;
        },
        get: function () {
          return entrega;
        },
      };
    },
  };
};
